module.exports = __webpack_public_path__ + "static/media/kamikazi.1f86a3b1.jpg";